import { render, staticRenderFns } from "./WaitingOrder.vue?vue&type=template&id=0e472d2a&scoped=true"
import script from "./WaitingOrder.vue?vue&type=script&lang=js"
export * from "./WaitingOrder.vue?vue&type=script&lang=js"
import style0 from "./WaitingOrder.vue?vue&type=style&index=0&id=0e472d2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e472d2a",
  null
  
)

export default component.exports